import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Modal,
  Card,
  CardHeader,
  Table,
} from "reactstrap";
import DetailedOrderCard from "../../components/DetailedOrderCard";
import RequestManager from "../../singletons/RequestManager";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

export default class ActiveOrdersPaymentPending extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      storeInformation: null,
      startDate: moment().endOf("day"),
      endDate: moment().endOf("day"),
      pageText: "Payment pending orders",
      printSdkType: "",
    };
  }

  componentWillMount() {
    this.checkLoginMode();
  }
  componentDidMount() {
    this.getOrders();
  }

  checkLoginMode = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "merchant") {
      this.setState({
        storeInformation: storeInformation,
        pageText: "Your Order Summary",
      });
    } else {
      this.setState({ storeInformation: storeInformation });
    }
  };

  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible,
    });
  };

  handleStartDateChange = (date) => {
    this.setState({
      startDate: date,
    });
  };
  handleEndDateChange = (date) => {
    if (
      Date.parse(this.state.startDate.format("MM/DD/YYYY")) >=
      Date.parse(date.format("MM/DD/YYYY"))
    ) {
      if (
        Date.parse(this.state.startDate.format("MM/DD/YYYY")) ===
        Date.parse(date.format("MM/DD/YYYY"))
      ) {
        this.setState({
          endDate: date,
        });

        console.log("endDate 1" + date.format("MM/DD/YYYY"));
      } else {
        alert("End date should be greater than Start date");
      }
    } else {
      console.log("endDate 2" + date);
      this.setState({
        endDate: date,
      });
    }
  };

  getOrders = async () => {
    let requestManager = new RequestManager();
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let loginMode = localStorage.getItem("loginMode");
    let params = {};
    if (loginMode === "store") {
      params = {
        storeId: storeInformation.store.id,
      };
    } else if (loginMode === "merchant") {
      params = {
        merchantId: storeInformation.merchant.id,
      };
    }

    // let date='';
    // if (this.state.startDate !== null) {
    //   date = this.state.startDate.format("YYYY-MM-DDT");
    //   date = date+"00:00:00+05:30";
    //   params.createdAt_Gte = date;
    // }
    // if (this.state.endDate !== null) {
    //   params.createdAt_Lte = this.state.endDate.format();
    // }

    let response = await requestManager.getResponseFromPredefinedQuery(
      "getOrders",
      params
    );

    if (response.error === null) {
      let orders = [];
      for (let i = 0; i < response.data.orderHistory.edges.length; i++) {
        let total = response.data.orderHistory.edges[i].node.cart.total;
        let payments =
          response.data.orderHistory.edges[i].node.cart.checkout.payments.edges;
        let paid = false;
        if (response.data.orderHistory.edges[i].node.status !== "REJECTED") {
          for (let i = 0; i < payments.length; i++) {
            if (
              (payments[i].node.status === "SUCCESS" ||
                payments[i].node.status === "PROCESSED") &&
              // eslint-disable-next-line
              parseInt(payments[i].node.amount) >= parseInt(total)
            ) {
              paid = true;
            }
          }
          if (paid === false) {
            orders.push(response.data.orderHistory.edges[i]);
          }
        }
      }

      this.setState({
        orders: orders,
      });
    }

    console.log("getOrders", response);
  };

  getPayment = (order) => {
    let total = order.node.cart.total;
    let payments = order.node.cart.checkout.payments.edges;
    let paid = false,
      paidText = "Payment Pending";
    for (let i = 0; i < payments.length; i++) {
      if (
        (payments[i].node.status === "SUCCESS" ||
          payments[i].node.status === "PROCESSED") 
          
          /*&&
        // eslint-disable-next-line
        parseInt(payments[i].node.amount) >= parseInt(total)
        // Santosh commented checking for cart amount to payment amount , as it does not account for checkoutleve discounts
        */
      ) {
        paid = true;
      }
    }
    if (paid) {
      paidText = "PAID";
    }
    return paidText;
  };
  getCountOfItems = () => {
    if (this.state.selectedOrder) {
      let cartItems = this.state.selectedOrder.node.cart.cartItems.edges;
      let quantity = 0;
      cartItems.forEach((cartItem) => {
        quantity = quantity + cartItem.node.quantity;
      });

      return quantity;
    }
  };

  getCSVData = () => {
    let date = "";
    if (this.state.startDate !== null) {
      date = this.state.startDate.format("YYYY-MM-DDT");
      date = date + "00:00:00+00:00";
    }
    let csvData = [
      [this.state.pageText],
      ["Grand Total", "Start Date", "End Date"],
      [this.state.grandTotal, date, this.state.endDate.format()],
      [""],
      [""],
      ["Order Id", "Token", "Status", "Date/Time", "Amount", "Store"],
    ];
    // eslint-disable-next-line
    this.state.orders.map((order) => {
      csvData.push([
        order.node.orderId,
        order.node.storeToken,
        order.node.status,
        moment(order.node.createdAt).format("MMMM Do YYYY, h:mm a"),
        order.node.cart.settlementPrice,
        order.node.cart.pickupPoint.store.name,
      ]);
    });
    // eslint-disable-next-line
    return csvData;
  };

  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0 }}>
        <Modal
          isOpen={this.state.orderModalVisible}
          toggle={this.toggleModal}
          size="lg"
        >
          <DetailedOrderCard
            editable={true}
            order={this.state.selectedOrder}
            toltalItemCount={null}
            goBack={this.toggleModal}
            refreshOrders={this.getOrders}
            pastOrder={true}
            storeInformation={this.state.storeInformation}
          />
        </Modal>

        <Row noGutters>
          <Col>
            <Card>
              <CardHeader>
                <Container fluid>
                  <Row>
                    <Col
                      xs="12"
                      sm="12"
                      md="4"
                      lg="4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <h5>{this.state.pageText}</h5>
                    </Col>
                  </Row>
                </Container>
              </CardHeader>
              <Table responsive>
                <tbody>
                  <tr>
                    <th>Order Id</th>
                    <th>Token</th>
                    <th>Payment</th>
                    <th>status</th>
                    <th>Date/Time</th>
                    <th>Amount</th>
                    <th>Store</th>
                  </tr>
                  {this.state.orders.map((order) => {
                    return (
                      <tr
                        key={order.node.id}
                        onClick={() => {
                          this.setState({ selectedOrder: order });
                          this.toggleModal();
                        }}
                      >
                        <td>{order.node.orderId}</td>
                        <td>{order.node.storeToken}</td>
                        <td>{this.getPayment(order)}</td>
                        <td>{order.node.status}</td>
                        <td>
                          {moment(order.node.createdAt).format(
                            "MMMM Do YYYY, h:mm a"
                          )}
                        </td>
                        <td>{"₹" + order.node.cart.settlementPrice}</td>
                        <td>{order.node.cart.pickupPoint.store.name}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ActiveOrdersPaymentPending/ActiveOrdersPaymentPending.js